import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as PhoneIcon } from './phone.svg';

export const Phone = IconHOC(PhoneIcon);
